function cleanNumber(val) {
  if (!val) return null;
  return String(val).replace(/[^\d.,]/g, '').replace(',', '.');
}

function updateVariantSpecs(variantId) {
  const dataEl = document.querySelector('[data-variant-metafields]');
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('Invalid JSON in data-variant-metafields');
    return;
  }

  const specs = data[variantId];
  if (!specs) return;

  const heightEl = document.querySelector('[data-height]');
  const widthEl  = document.querySelector('[data-width]');
  const weightEl = document.querySelector('[data-weight]');

  const h_cm = cleanNumber(specs.height_cm);
  const h_in = cleanNumber(specs.height_in);
  const w_cm = cleanNumber(specs.width_cm);
  const w_in = cleanNumber(specs.width_in);
  const wt   = cleanNumber(specs.weight);

  if (heightEl) {
    heightEl.textContent =
      h_cm ? `Height: ${h_cm}cm${h_in ? ` (${h_in}in)` : ''}` : '';
  }

  if (widthEl) {
    widthEl.textContent =
      w_cm ? `Width: ${w_cm}cm${w_in ? ` (${w_in}in)` : ''}` : '';
  }

  if (weightEl) {
    weightEl.textContent = wt ? `Weight: ${wt}g` : '';
  }
}

/* Initial load */
document.addEventListener('DOMContentLoaded', () => {
  const variantInput =
    document.querySelector('[name="id"]:checked') ||
    document.querySelector('[name="id"]');

  if (variantInput) updateVariantSpecs(variantInput.value);
});

/* Variant change */
document.addEventListener('change', (e) => {
  if (e.target.name === 'id') {
    updateVariantSpecs(e.target.value);
  }
});
